/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-06-07 11:26:17
 * @LastEditors: linxi
 * @LastEditTime: 2023-06-19 18:50:09
 */
import React, { useEffect, useState } from 'react'
import {
  Form,
  Modal,
  notification,
  Tabs,
  Tree,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import styles from './versionManagement.module.css'
import { TabPane } from '../../compnents/widgets/TabBar'
import { RootDispatch } from '../../app/store'

import {
  getAllMenuListAsync,
  getMenuListAsync,
  getSelectMenus,
  getAllSelectMenusSubmit,
} from './versionManagementSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import _ from 'lodash'

export const EditMenuVersionModal = (props: {
  versionEdition?: any
  id?: number
  projectName?: string
  visible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [tabsKey, setTabsKey] = useState<any>('0')

  const [loading, setLoading] = useState(false)

  const [checkedKeys, setCheckedKeys] = useState<any>([])

  const [menuList, setMenus] = useState<any>([])
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])

  // 只收集第一级父节点的key，避免一次性渲染过多DOM导致卡顿
  const collectExpandKeys = (nodes: any): React.Key[] => {
    return nodes.map((node: any) => node.key)
  }

  const onExpand = (keys: React.Key[]) => {
    setExpandedKeys(keys)
  }

  const onCheck = (checkedKeysValue: any, info: any) => {
    setCheckedKeys(checkedKeysValue);
  }

  // 获取所有选中节点的父节点
  const getParentKeys = (treeData: any, key: number) => {
    const parentKeys: any = [];
    const dfs = (nodes: any, parent: any) => {
      nodes.forEach((node: any) => {
        if (node.key === key) {
          parentKeys.push(parent);
        } else if (node.children) {
          dfs(node.children, node.key);
        }
      });
    };
    dfs(treeData, null);
    return parentKeys;
  }

  //获取节点的数据
  const getNodeData = (treeData: any, key: number) => {
    let nodeKey: any = {};
    const dfs = (nodes: any) => {
      nodes.forEach((node: any) => {
        if (node.key === key) {
          nodeKey = node;
        } else if (node.children) {
          dfs(node.children);
        }
      });
    };
    dfs(treeData);
    return nodeKey;
  }

  // 递归收集已选中的菜单（status === 1 的最深层节点）
  const collectCheckedIds = (nodes: any, result: any[] = []): any[] => {
    nodes?.forEach((node: any) => {
      if (node?.children?.length > 0 && node.status == 1) {
        collectCheckedIds(node.children, result)
      } else if (node.status == 1) {
        result.push(Number(node.id))
      }
    })
    return result
  }

  useEffect(() => {
    if (props?.visible) {
      if (props?.versionEdition?.toString()) {
        dispatch(getAllMenuListAsync({ edition: props?.versionEdition, versionId: props?.id }))
          .then(unwrapResult)
          .then((res: any) => {
            const tree = res?.map((v: any) => {
              return {
                ...v,
                title: v?.name,
                key: Number(v?.id),
                children: v?.children?.map((i: any) => {
                  return {
                    ...i,
                    title: i?.name,
                    key: Number(i?.id),
                    children: i?.children?.map((j: any) => {
                      return {
                        ...j,
                        title: j?.name,
                        key: Number(j?.id),
                        children: j?.children?.map((k: any) => {
                          return {
                            ...k,
                            title: k?.name,
                            key: Number(k?.id),
                          }
                        }),
                      }
                    }),
                  }
                }),
              }
            })
            const allTreeData = [
              {
                title: '全部',
                key: 0,
                children: tree
              }
            ]
            setMenus(allTreeData)
            setExpandedKeys(collectExpandKeys(allTreeData))
            setCheckedKeys(collectCheckedIds(res))
          })
      }
    }
  }, [props?.versionEdition, props?.visible])

  useEffect(() => {
    if (props?.visible) {
      setTabsKey(props?.versionEdition)
    }
  }, [props?.visible, props?.versionEdition])

  useEffect(() => {
    if (!props?.visible) {
      setCheckedKeys([])
    }
  }, [props?.visible])

  return (
    <div>
      <Modal
        className={styles.model}
        title='菜单编辑权限'
        visible={props.visible}
        okText='确认'
        cancelText='取消'
        confirmLoading={loading}
        onOk={() => {
          setLoading(true)
          let checkIds: any = []
          checkedKeys?.forEach((v: any) => {
            checkIds.push(...getParentKeys(menuList, v))
          })
          checkIds = Array.from(new Set(checkIds.concat(checkedKeys)))?.filter(v => !!v)
          let newCheckIds: any = []
          checkIds?.forEach((v: any) => {
            newCheckIds.push(...getParentKeys(menuList, v))
          })
          newCheckIds = Array.from(new Set(newCheckIds.concat(checkIds)))?.filter(v => !!v)
          let finailyCheckIds: any = []
          newCheckIds?.forEach((v: any) => {
            finailyCheckIds.push(...getParentKeys(menuList, v))
          })
          finailyCheckIds = Array.from(new Set(finailyCheckIds.concat(newCheckIds)))?.filter(v => !!v)
          const data = finailyCheckIds?.map((v: any) => {
            const node = getNodeData(menuList, v)
            return {
              level: node?.level,
              menuId: node?.key
            }
          })
          dispatch(
            getAllSelectMenusSubmit({
              versionId: props?.id,
              menuList: data,
            })
          )
            .then(unwrapResult)
            .then((v: any) => {
              notification.success({
                message: '操作成功',
              })
              form.resetFields()
              props.onOk()
              setTabsKey('')
            })
            .finally(() => {
              setLoading(false)
              form.resetFields()
              props.onOk()
              setTabsKey('')
            })
        }}
        onCancel={() => {
          form.resetFields()
          props.onCancel()
          setTabsKey('')
        }}
        width='850px'
      >
        <Tabs
          defaultActiveKey={props?.versionEdition?.toString() || '0'}
          className={styles.tabs}
          onChange={(v) => {
            setTabsKey(v)
          }}
          activeKey={props?.versionEdition?.toString() || '0'}
        >
          {props?.versionEdition == '0' ? (
            <TabPane key='0' tab='通用菜单'>
              <Tree
                checkable
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                treeData={menuList}
                expandedKeys={expandedKeys}
                defaultExpandAll={true}
                onExpand={onExpand}
              />
            </TabPane>
          ) : props?.versionEdition == '1' ? (
            <TabPane key='1' tab='口腔菜单'>
              <Tree
                checkable
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                treeData={menuList}
                expandedKeys={expandedKeys}
                defaultExpandAll={true}
                onExpand={onExpand}
              />
            </TabPane>
          ) : (
            ''
          )}
        </Tabs>
      </Modal>
    </div>
  )
}
